import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { setModelPanel } from "../redux/modelPanelSlice";
import { Link } from "react-router-dom";
import { apiURL } from "../config";
import { newConversation } from "../redux/conversationIdSlice";
import { setMessagesStatus } from "../redux/messagesStatusSlice";

function NavBar() {
  const sideBarState = useSelector((state) => state.sideBar);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const modelPanel = useSelector((state) => state.modelPanel);

  const handleLogOut = async function (event) {
    event.preventDefault();
    const response = await fetch(`${apiURL}/api/logout`, {
      method: "GET",
      credentials: "include",
    });

    const data = await response.json();
    //console.log(data)
    if (data.message === "SUCCESS") {
      window.location.reload();
      //navigate('/')
    }
  };

  return (
    <div
      className={`fixed top-0 right-0 select-none bg-gradient-to-b from-[rgb(45,45,42)] from-25% border-black z-[600] px-2 transition-all ${
        sideBarState === "left-sidebar" ? "left-52" : "left-0"
      }`}
    >
      <div className="flex justify-between items-center p-4  text-white">
        <div className="flex items-center gap-2">
          {sideBarState !== "left-sidebar" && (
            <div
              className="w-8 h-8 p-[6px] opacity-75 border border-[hsla(var(--border-100))] rounded-md -translate-x-2 hover:scale-105 select-none cursor-pointer transition"
              onClick={() => {
                dispatch(newConversation());
                dispatch(setMessagesStatus("NEW"));
              }}
            >
              {rightArrowSVG}
            </div>
          )}
          <div className="text-2xl font-bold ">ChatBot</div>
        </div>
        <div className="flex space-x-2 items-center">
          {user.username === "" ? (
            <Link
              to="/login"
              className="px-3 py-1 text-white hover:scale-105 transition cursor-pointer"
            >
              Log in
            </Link>
          ) : (
            <>
              <div className="text-neutral-400 font-bold">{user.username}</div>
              <div
                className="px-3 py-1 text-white hover:scale-105 transition cursor-pointer"
                onClick={(e) => handleLogOut(e)}
              >
                Log out
              </div>
            </>
          )}
          <div
            onClick={() => {
              switch (modelPanel) {
                case "hidden-right":
                  dispatch(setModelPanel("right"));
                  break;
                case "right":
                  dispatch(setModelPanel("hidden-right"));
                  break;
                case "hidden-bottom":
                  dispatch(setModelPanel("bottom"));
                  break;
                case "bottom":
                  dispatch(setModelPanel("hidden-bottom"));
                  break;
                default:
                  dispatch(setModelPanel("right"));
              }
            }}
          >
            <div className="w-8 h-8 fill-white/80  border border-[hsla(var(--border-300))] rounded-md p-1 cursor-pointer hover:scale-105 transition">
              {settingsSVG}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const rightArrowSVG = (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    stroke="white"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="none"
    color="white"
    className="translate-x-[1px] -translate-y-[1px]"
  >
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path d="M19 14V22H2.99997V4H13"></path>{" "}
      <path d="M17.4608 4.03921C18.2418 3.25817 19.5082 3.25816 20.2892 4.03921L20.9608 4.71079C21.7418 5.49184 21.7418 6.75817 20.9608 7.53921L11.5858 16.9142C11.2107 17.2893 10.702 17.5 10.1716 17.5L7.5 17.5L7.5 14.8284C7.5 14.298 7.71071 13.7893 8.08579 13.4142L17.4608 4.03921Z"></path>{" "}
      <path d="M16.25 5.25L19.75 8.75"></path>{" "}
    </g>
  </svg>
);

const settingsSVG = (
  <svg
    version="1.1"
    id="Uploaded to svgrepo.com"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <style type="text/css"> </style>{" "}
      <path
        className="linesandangles_een"
        d="M26,21h-6v2H4v2h16v2h6v-2h2v-2h-2V21z M24,25h-2v-2h2V25z M12,13H6v2H4v2h2v2h6v-2h16v-2H12V13 z M10,17H8v-2h2V17z M22,7V5h-6v2H4v2h12v2h6V9h6V7H22z M20,9h-2V7h2V9z"
      ></path>{" "}
    </g>
  </svg>
);

export default NavBar;
